<template>
  <div class="faq-list">
    <a-spin
      tip="Loading..."
      :spinning="loadings.loading"
    >
      <ai-card
        :item="content"
        class="ai-card"
        :limit="0"
        :retain-item="true"
      ></ai-card>
    </a-spin>
  </div>
</template>
<script>
import { searchFAQ } from "@/api/index";
export default {
  name: "faqList",
  components: {
    aiCard: () => import("./component/aiCard")
  },
  props: {
    q: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      content: {},
      loadings: {
        loading: false
      }
    };
  },
  methods: {
    search(keyWords) {
      let {platform} = this.$bus.pageInfo
      this.$bus.$emit("loading", this.loadings);
      let { gameIdKey, alias } = this.$route.params
      searchFAQ(keyWords, gameIdKey, alias, platform).then(res => {
        let { sectionList } = res;
        let contentList = sectionList.reduce((total, item) => {
          item.contentList.forEach(li => {
            li.sectionIdKey = item.sectionIdKey;
          });
          return total.concat(item.contentList);
        }, []);
        this.content = {
          contentList,
          sectionName: this.$t('index.searchResult.searchResult'),
          sectionId: "searchId",
          gameIdKey: gameIdKey
        };
      });
    }
  }
};
</script>
<style lang="scss">
.faq-list {
  .breadcrumb {
  }
  .ai-card {
    // margin-top: 20px;
  }
}
</style>